import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import ConfirmationModal from '../../common_components/ConfirmationModal';
import { useNavigate } from 'react-router-dom';

const GroceryListModal = ({ show, handleClose, currentList = {}, fetchGroceryLists, refreshLists }) => {
    const [editState, setEditState] = useState(false);
    const [formState, setFormState] = useState({
        name: '',
        description: '',
        status: 'ACTIVE',
        is_default: false,
    });
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [confirmationModalConfig, setConfirmationModalConfig] = useState({
        show: false,
        title: '',
        body: '',
        onConfirm: () => { },
    });

    useEffect(() => {
        if (show) {
            if (currentList.uuid) {
                setEditState(true);
                setFormState({
                    name: currentList.name,
                    description: currentList.description,
                    status: currentList.status,
                    is_default: currentList.is_default,
                });
            } else {
                setEditState(false);
                setFormState({
                    name: '',
                    description: '',
                    status: 'ACTIVE',
                    is_default: false,
                });
            }
        }
    }, [show, currentList]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormState((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEditMode = Boolean(currentList.uuid);
        const apiUrl = isEditMode
            ? `${process.env.REACT_APP_BACKEND_API_URL}/highgarden/household-grocery-lists/${currentList.uuid}/`
            : `${process.env.REACT_APP_BACKEND_API_URL}/highgarden/household-grocery-lists/`;

        const config = {
            headers: {
                Authorization: `Token ${token}`,
            },
        };

        try {
            const response = isEditMode
                ? await axios.patch(apiUrl, formState, config)
                : await axios.post(apiUrl, formState, config);

            if (response.status === 200 || response.status === 201) {
                fetchGroceryLists();
                refreshLists();
                handleClose();
            }
        } catch (error) {
            console.error(`Error ${isEditMode ? 'updating' : 'creating'} grocery list:`, error);
        }
    };

    const deleteList = async () => {
        const apiUrl = `${process.env.REACT_APP_BACKEND_API_URL}/highgarden/household-grocery-lists/${currentList.uuid}/`;
        try {
            const response = await axios.delete(apiUrl, {
                headers: { Authorization: `Token ${token}` },
            });
            if (response.status === 204) {
                fetchGroceryLists();
                navigate('/highgarden/grocery_lists');
                handleClose();
                setConfirmationModalConfig(prev => ({ ...prev, show: false }));
                refreshLists();
                console.log('List deleted successfully');
            }
        } catch (error) {
            console.error('Error deleting list:', error);
        }
    };

    const handleOpenListDeleteConfirmModal = () => {
        setConfirmationModalConfig({
            show: true,
            title: 'Delete List',
            body: 'Are you sure you want to delete this list? This action cannot be undone.',
            onConfirm: deleteList,
        });
    };

    return (
        <Container>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{editState ? 'Edit List' : 'Create List'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formState.name}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="description"
                                value={formState.description}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="status-tooltip">Set as default list</Tooltip>}
                            >
                                <Form.Check
                                    type="switch"
                                    id="default-switch"
                                    label="Default List"
                                    checked={formState.is_default}
                                    onChange={handleChange}
                                    name="is_default"
                                />
                            </OverlayTrigger>
                        </Form.Group>
                        <div className="d-flex justify-content-between">
                            <Button
                                className="custom-button-portal"
                                variant="primary"
                                style={{ width: '200px', backgroundColor: '#4b88a2' }}
                                type="submit"
                            >
                                {editState ? 'Save Changes' : 'Create New List'}
                            </Button>
                            {editState && (
                                <Button
                                    className="custom-button-portal"
                                    variant="danger"
                                    style={{ width: '200px', backgroundColor: '#d9534f' }}
                                    onClick={handleOpenListDeleteConfirmModal}
                                >
                                    Delete List
                                </Button>
                            )}
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <ConfirmationModal
                show={confirmationModalConfig.show}
                onHide={() => setConfirmationModalConfig(prev => ({ ...prev, show: false }))}
                onConfirm={confirmationModalConfig.onConfirm}
                title={confirmationModalConfig.title}
                body={confirmationModalConfig.body}
            />
        </Container>
    );
};

export default GroceryListModal;
